import { atom } from "nanostores";

export const $allByFundId = atom<string | undefined>(undefined);

export const allByFundIdActions = {
  setAllByFundId: (id: string) => {
    $allByFundId.set(id);
  },
  clean: () => {
    $allByFundId.set(undefined);
  },
};
